// JavaScript Document

/*********************
//* jQuery Multi Level CSS Menu #2- By Dynamic Drive: http://www.dynamicdrive.com/
//* Last update: Nov 7th, 08': Limit # of queued animations to minmize animation stuttering
//* Menu avaiable at DD CSS Library: http://www.dynamicdrive.com/style/
*********************/

//Specify full URL to down and right arrow images (23 is padding-right to add to top level LIs with drop downs):
var arrowimages={down:['downarrowclass', 'down.gif', 23], right:['rightarrowclass', 'right.gif']}

var jqueryslidemenu={

animateduration: {over: 200, out: 100}, //duration of slide in/ out animation, in milliseconds

buildmenu:function(menuid, arrowsvar){
	jQuery(document).ready(function($){
		var $mainmenu=$("#"+menuid+">ul")
		var $headers=$mainmenu.find("ul").parent()
		
		$headers.each(function(i){
			var $curobj=$(this)
			var $subul=$(this).find('ul:eq(0)')
			this._dimensions={w:this.offsetWidth, h:this.offsetHeight, subulw:$subul.outerWidth(), subulh:$subul.outerHeight()}
			this.istopheader=$curobj.parents("ul").length==1? true : false
			
			$subul.css({top:this.istopheader? this._dimensions.h-1+"px" : 0})
			
			$curobj.hover(
				function(e){
					//alert($(this).html());
					$(this).children('a').attr("class","lihoverclass");
					$mainmenu.find("ul").parent().addClass("fixed");
					//$mainmenu.find(".nav ul li a").parent().addClass("parent");
					var $targetul=$(this).children("ul:eq(0)")
					
					this._offsets={left:$(this).offset().left, top:$(this).offset().top}
					var menuleft=this.istopheader? 0 : this._dimensions.w
					menuleft=(this._offsets.left+menuleft+this._dimensions.subulw>$(window).width())? (this.istopheader? -this._dimensions.subulw+this._dimensions.w : -this._dimensions.w) : menuleft
					if ($targetul.queue().length<=1) //if 1 or less queued animations
						$targetul.css({left:menuleft+"px", width:this._dimensions.subulw+'px'}).slideDown(jqueryslidemenu.animateduration.over)
				},
				function(e){
					var $targetul=$(this).children("ul:eq(0)")
					$targetul.slideUp(jqueryslidemenu.animateduration.out)
					$(this).children('a').attr("class","");
					$mainmenu.find("ul").parent().removeClass("fixed");
				}
			) //end hover
		}) //end $headers.each()
		$mainmenu.find("ul").css({display:'none', visibility:'visible'})
	}) //end document.ready
}
}

//build menu with ID="myslidemenu" on page:
jqueryslidemenu.buildmenu("myslidemenu", arrowimages)


var a = 0;
	function display(){
		if(a == 0){
			$('#myslidemenu').addClass('menushow');
			a = 1;
		}
		else if(a == 1){
			$('#myslidemenu').removeClass('menushow');
			a = 0;
		}		
	}

jQuery.noConflict()(function($){ 
  
    $("#Search-icon").click(function(){
        $(".top-search-box").toggle();
		$(".top-search-right").click(function(){
			$(".top-search-box").hide();			
		});
    });
	
	var slider = $('.bx_product_slider').bxSlider({
		auto: false,  
		speed: 500,
		mode: 'horizontal',
		pager: false,
		controls: false,
		minSlides: 1,
		moveSlides: 1,
		maxSlides: 3,
		slideWidth: 250,
		slideMargin: 10,
		infiniteLoop: true
	});	
	
	$('#left_product').click(function(){
		slider.goToPrevSlide();
		return false;
	});	

	$('#right_product').click(function(){
		slider.goToNextSlide();
		return false;
	});
	
	var slider2 = $('.bx_testimonial_slider').bxSlider({
		auto: true,  
		speed: 500,
		mode: 'horizontal',
		pager: false,
		controls: false,
		minSlides: 1,
		moveSlides: 1,
		maxSlides: 2,
		slideWidth: 280,
		slideMargin: 10,
		infiniteLoop: true
	});	
	
	$('#left_testimonial').click(function(){
		slider2.goToPrevSlide();
		return false;
	});	

	$('#right_testimonial').click(function(){
		slider2.goToNextSlide();
		return false;
	});

	
});